export const Door = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1367.024"
    height="1435"
    viewBox="0 0 1367.024 1435"
  >
    <g
      id="联合_2"
      data-name="联合 2"
      transform="translate(643 643)"
      fill="none"
    >
      <path
        d="M0,149V40.689H0C.306,18.165,18.321,0,40.5,0S80.694,18.165,81,40.689h0V149Z"
        stroke="none"
      />
      <path
        d="M 81 149.0000457763672 L 80.99600219726562 40.68871307373047 C 80.69400024414062 18.16537857055664 62.6793327331543 4.57763671875e-05 40.5 4.57763671875e-05 C 18.3206672668457 4.57763671875e-05 0.3059999942779541 18.16537857055664 0.004000000189989805 40.68871307373047 L 0 40.68871307373047 L 0 149.0000457763672 L 81 149.0000457763672 M 724.0239868164062 792.0000610351562 L -643 792.0000610351562 L -643 36.89337921142578 L -642.940673828125 31.95404624938965 C -637.8846435546875 -340.21728515625 -331.2940063476562 -642.9999389648438 40.5 -642.9999389648438 C 412.3580017089844 -642.9999389648438 718.9473266601562 -340.1659545898438 723.93798828125 32.06804656982422 L 723.9959716796875 36.36604690551758 L 724.0239868164062 792.0000610351562 Z"
        stroke="none"
        fill="#0cadcb"
      />
    </g>
  </svg>
);

export const Star1 = (
  <svg
    width="128"
    height="126"
    viewBox="0 0 128 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M67.3004 49.1963L64.8104 0.667471L61.3007 49.1333C60.7798 51.1279 59.7536 53.6172 56.2801 51.0806L41.3911 40.4235L53.7382 55.0541C55.2223 56.5698 53.9897 59.657 51.1856 60.0275L0.657004 62.4965L51.1173 66.5272C53.1172 66.5482 54.0961 68.5586 52.5752 70.5427L40.9129 85.921L56.0383 74.0793C58.5592 72.1057 61.0484 73.1319 61.0221 75.6318L63.4965 125.661L67.0219 75.6949C67.0587 72.1951 70.5585 72.2318 73.0373 74.258L86.9261 84.9046L75.5739 70.7845C74.095 68.7688 75.116 66.7794 77.1159 66.8005L127.65 63.8315L77.1842 60.3008C74.3886 59.8714 74.2159 57.2695 75.7316 55.7853L87.3729 42.4069L73.2685 52.2592C68.2373 55.2065 67.2794 51.1962 67.3004 49.1963Z"
      fill="white"
      stroke="black"
    />
  </svg>
);

export const Star2 = (
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.09885 25.4936C15.5452 23.5154 23.83 15.403 26.0274 5.00047C28.0056 15.4468 36.118 23.7317 46.5205 25.929C36.0741 27.9072 27.7893 36.0196 25.592 46.4221C23.6138 35.9758 15.5013 27.6909 5.09885 25.4936Z"
      fill="white"
      stroke="black"
    />
  </svg>
);

export const Star3 = (
  <svg
    width="96"
    height="95"
    viewBox="0 0 96 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M47.4465 22.3074L47.617 14.0888L48.0537 22.2976C48.7744 35.8455 59.7974 46.5435 73.3264 46.82L82.0045 46.9973L73.3367 47.4558C59.8237 48.1705 49.1532 59.2201 48.8719 72.7843L48.7015 81.0029L48.2648 72.7941C47.5441 59.2462 36.5211 48.5482 22.9921 48.2718L14.3139 48.0944L22.9818 47.636C36.4947 46.9212 47.1653 35.8716 47.4465 22.3074Z"
      fill="white"
      stroke="black"
    />
  </svg>
);

export const Star4 = (
  <svg
    width="107"
    height="103"
    viewBox="0 0 107 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.6102 1.3323L47.7326 39.6409L36.0558 28.8287L45.2734 42.1811L12.4536 22.7104L41.3225 45.2455L27.7757 42.4647L41.3712 48.2451L1.43314 52.3929L41.4522 53.2444L28.0431 58.9625L41.5089 56.744L13.4097 81.7026L45.5732 60.6786L38.2687 72.7986L48.0729 60.6381L38.7467 102.295L52.1048 62.573L55.3718 79.0223L55.1044 62.5244L71.6938 98.7603L60.1037 62.4434L69.2322 70.2965L63.5708 60.3869L95.8665 78.3659L65.5058 56.3551L79.5363 58.1279L66.9488 52.8312L106.387 48.6915L66.8678 47.8319L79.2689 41.6301L65.3194 44.8566L94.8941 18.3738L61.7712 41.9137L68.584 30.3017L59.731 39.4464L68.1059 0.805618L54.7154 38.5276C54.3092 34.0336 53.4919 24.7456 53.4725 23.5457C53.453 22.3459 52.2825 32.3995 51.6996 37.5763L35.6102 1.3323Z"
      fill="white"
      stroke="black"
      strokeLinejoin="round"
    />
  </svg>
);

export const FrontArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
  >
    <g id="组_1" data-name="组 1" transform="translate(-1048.357 -89)">
      <line
        id="直线_3"
        data-name="直线 3"
        x2="14.835"
        transform="translate(1051.372 100.463)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="1"
      />
      <line
        id="直线_4"
        data-name="直线 4"
        x2="6.743"
        y2="6.743"
        transform="translate(1059.463 93.72)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="1"
      />
      <line
        id="直线_5"
        data-name="直线 5"
        y1="6.743"
        x2="6.743"
        transform="translate(1059.463 100.463)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="1"
      />
      <g
        id="椭圆_3"
        data-name="椭圆 3"
        transform="translate(1048.357 89)"
        fill="none"
        stroke="#000"
        strokeWidth="1"
      >
        <circle cx="11.5" cy="11.5" r="11.5" stroke="none" />
        <circle cx="11.5" cy="11.5" r="11" fill="none" />
      </g>
    </g>
  </svg>
);

export const close_icon_black = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28.598"
    height="28.598"
    viewBox="0 0 28.598 28.598"
  >
    <line
      id="直线_6"
      data-name="直线 6"
      x2="25.77"
      y2="25.77"
      transform="translate(1.414 1.414)"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth="2"
    />
    <line
      id="直线_7"
      data-name="直线 7"
      y1="25.77"
      x2="25.77"
      transform="translate(1.414 1.414)"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth="2"
    />
  </svg>
);

export const close_icon_white = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28.598"
    height="28.598"
    viewBox="0 0 28.598 28.598"
  >
    <line
      id="直线_8"
      data-name="直线 8"
      x2="25.77"
      y2="25.77"
      transform="translate(1.414 1.414)"
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth="2"
    />
    <line
      id="直线_9"
      data-name="直线 9"
      y1="25.77"
      x2="25.77"
      transform="translate(1.414 1.414)"
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth="2"
    />
  </svg>
);
